export let SliderComponent = {
    selector: 'editarSlider',
    template: require('./sliders.html'),
    bindings: {
        slides: '<',
        categorias: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(UTIL_URL, Upload, ConfiguracionService, $route, ToasterService) {
            Object.assign(this, {UTIL_URL, Upload, ConfiguracionService, $route, ToasterService});
            this.subiendoArchivo = false;
        }

        $onInit() {
            (this.slides || []).forEach(slide => {
                slide.categoria = slide.categoria || null;
                slide.subcategoria = slide.subcategoria || null;
            });
        }

        uploadFiles(file, err) {
            if (err.length === 0)
                this.file = file;
        }

        subirSlide() {
            if (this.file) {
                this.subiendoArchivo = true;
                this.Upload.upload({
                        url: `${this.UTIL_URL}/slides/upload`,
                        data: {
                            categoria: (this.categoriaSeleccionada ? this.categoriaSeleccionada.categoria : ''),
                            subcategoria: (this.subcategoriaSeleccionada ? this.subcategoriaSeleccionada.subcategoria : ''),
                            file: this.file
                        }
                    })
                    .then((res) => {
                        this.ToasterService.popUp('success','Slider', 'Se ha creado con éxito.');
                        this.$route.reload();
                    })
            } else {
                this.subiendoArchivo = false;
                this.ToasterService.popUp('info','Informacion', 'Seleccione una imagen.');
            }
        }

        subcategoriasDe(nombreCategoria) {
            const categoria = (this.categorias || []).find(item => item.categoria === nombreCategoria);
            return categoria ? categoria.subcategorias : [];
        }

        cambiarCategoriaSlide(slide) {
            slide.subcategoria = null;
        }

        guardarDestinoSlide(slide) {
            this.ConfiguracionService.actualizarSlide(slide._id, {
                    categoria: slide.categoria || '',
                    subcategoria: slide.subcategoria || ''
                })
                .then(data => {
                    this.ToasterService.popUp('success','Slider', 'Se ha actualizado el destino.');
                })
        }

        borrarSlide(id){
            this.ConfiguracionService.borrarSlide(id)
                .then( data => {
                    this.$route.reload();
                })
        }


    }
};



// WEBPACK FOOTER //
// ./client/app/configuracion-route/sliders/sliders.component.js